
import Wanchain from "../../../assets/duotone/Wanchain.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function WanchainIcon({ className, dataTestid = "WanchainIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Wanchain data-testid={dataTestid} className={classes} {...rest} />
  );
}
